import { BaseModel } from '@/api/base-model'
import { ReferralCountAPI } from '@/api/backend-client'
import { v4 } from 'uuid'

export class ReferralCount extends BaseModel<ReferralCount> {
    protected collectionName = ReferralCountAPI.collectionName

    constructor(
        public openLeads: number,
        public newLeads: number,
        public unreachableLeads: number,
        public pendingLeads: number,
        public appointmentLeads: number,
        public proposalLeads: number,
        public onHoldLeads: number,
        public processedLeads: number,
        public successfulLeads: number,
        public unsuccessfulLeads: number,
        public chanceHighLeads: number,
        public chanceNeutralLeads: number,
        public chanceLowLeads: number,
        public age90Leads: number,
        public age180Leads: number,
        public age365Leads: number,
        public teams: Array<{ branch: string, count: number }>,
    ) {
        super(v4())

        this.openLeads = openLeads
        this.newLeads = newLeads
        this.unreachableLeads = unreachableLeads
        this.pendingLeads = pendingLeads
        this.appointmentLeads = appointmentLeads
        this.proposalLeads = proposalLeads
        this.onHoldLeads = onHoldLeads
        this.processedLeads = processedLeads
        this.successfulLeads = successfulLeads
        this.unsuccessfulLeads = unsuccessfulLeads
        this.chanceHighLeads = chanceHighLeads
        this.chanceNeutralLeads = chanceNeutralLeads
        this.chanceLowLeads = chanceLowLeads
        this.age90Leads = age90Leads
        this.age180Leads = age180Leads
        this.age365Leads = age365Leads
        this.teams = teams
    }


    static fromData(data: any): ReferralCount {
        if (data === null || typeof data === 'string' || data instanceof ReferralCount) {
            return data
        }

        return new ReferralCount(
            data.openLeads,
            data.newLeads,
            data.unreachableLeads,
            data.pendingLeads,
            data.appointmentLeads,
            data.proposalLeads,
            data.onHoldLeads,
            data.processedLeads,
            data.successfulLeads,
            data.unsuccessfulLeads,
            data.chanceHighLeads,
            data.chanceNeutralLeads,
            data.chanceLowLeads,
            data.age90Leads,
            data.age180Leads,
            data.age365Leads,
            data.teams,
        )
    }
}
